module.exports = __webpack_public_path__ + "assets/img/8august_light.7d4dbb66.jpeg";